module.exports = __webpack_public_path__ + "e3c260870208f285f24abe344509c60c.svg";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/criminal.svg
// module id = 608
// module chunks = 0